import style from "./Checkbox.module.css"

const Checkbox = (props) => {
  function onChangeHandler(e) {
    props.onChange(e);
  }

  return (
    <label className={style.checkbox}>
      <input
        type="checkbox"
        checked={props.checked}
        onChange={onChangeHandler}
      />
      <span className={`${style.checkmark} ${"material-symbols-outlined"}`}></span>
      {props.value}
    </label>
  );
};

export default Checkbox;
